// extracted by mini-css-extract-plugin
module.exports = {"linkLang":"LocaleSelector_linkLang__XsWx_","linkLang__active":"LocaleSelector_linkLang__active__JgiPC"};